import { useEffect, useState } from "react";
import { SignIn } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import Button, { ButtonVariant } from "components/Button";

export const SignInModal = () => {
  const [opacityClass, setOpacityClass] = useState<string>("opacity-50");

  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      setOpacityClass("opacity-100");
    }, 10);
  }, []);

  return (
    <div className="bg-palette-5">
      <div
        className={`relative w-screen h-screen bg-transparent transition-opacity duration-300 ease-in-out ${opacityClass}`}
      >
        <div className="absolute top-4 right-4">
          <Button
            variant={ButtonVariant.Flat}
            icon={<FaTimes />}
            onClick={() => navigate(-1)}
            size="md"
          />
        </div>

        <div className="flex items-center justify-center h-full">
          <SignIn signUpUrl="/sign-up" />
        </div>
      </div>
    </div>
  );
};

export default SignInModal;
